<script lang="ts">
  import { readable } from "svelte/store";
  import { form as svelteForm, field } from "svelte-forms2";
  import { required } from "svelte-forms2/validators";
  import { lenientEmailValidator } from "@shared/svelte/Validators/Email";

  // services
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2.js";
  import { blur, change } from "@shared/services/svelte_form_input_service";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import FormInputError from "@shared/svelte/Components/FormInputError.svelte";
  import EmailInput from "@shared/svelte/Components/EmailInput.svelte";
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";

  const email = field("email", "", [required(), lenientEmailValidator()], {
    validateOnChange: false,
    stopAtFirstError: true,
  });
  const params = readable(window["stateParams"]);
  const passwordResetForm = svelteForm(email);

  let submitting: boolean = false;

  const flashPasswordResetError = () => {
    Flash.now({ type: "error", message: "Instructions not sent" });
  };

  const submitPasswordReset = async () => {
    await passwordResetForm.validate();

    if (!$passwordResetForm.valid) return;
    else submitting = true;

    await HttpPromise({
      method: "POST",
      url: "/users/password",
      data: { user: { email: $email.value } },
    })
      .then(res => {
        if (res?.errors) return flashPasswordResetError();

        window["stateService"].go("layout.passwordResetSent", { email: $email.value, ...$params });
      })
      .catch(_err => flashPasswordResetError())
      .finally(() => (submitting = false));
  };
</script>

<style>
  .fizz-layout-one-col-centered {
    min-height: 100vh;
  }
</style>

<PageTitle title="Password reset - Sign up | Provi" />
<div class="fizz-layout-one-col-centered fizz-surface-gray">
  <div data-grid-area="header">
    <h1 class="fizz-heading-1 fizz-stack-32 fizz-text-center">
      <Icon
        className={"fizz-margin-auto"}
        type="ProviLogo"
        height="50"
        width="166"
        fill="#002B48"
      />
    </h1>
  </div>
  <div data-grid-area="main" class="fizz-stack-32">
    <form
      class="fizz-card fizz-inset-squish-96 fizz-flow-24 fizz-radius-medium fizz-elevation-1"
      on:submit|preventDefault={submitPasswordReset}
    >
      <h2 class="fizz-heading-2 fizz-text-center fizz-stack-8">Reset your password</h2>
      <p class="fizz-text-small">
        Enter the email address you used to sign up for Provi and we'll send you instructions to
        reset your password.
      </p>
      <EmailInput
        name="email"
        label="Email"
        labelClasses="stack-8"
        field={email}
        on:blur={blur}
        on:change={change}
      >
        <FormInputError form={passwordResetForm} errorName="email.required">
          Email is required
        </FormInputError>
        <FormInputError form={passwordResetForm} errorName="email.email">
          Email format is invalid
        </FormInputError>
      </EmailInput>
      <button class="fizz-button-secondary fizz-full-width" type="submit" disabled={submitting}>
        Send Instructions
      </button>
      <p class="fizz-text-center fizz-text-small">
        <a href={"#"} on:click|preventDefault={() => (window.location.href = "/users/sign_in")}>
          Back to login
        </a>
      </p>
    </form>
  </div>
</div>
<FlashWrapper />
